import PropertyCard from '@/components/PropertyCard/PropertyCard';
import { useAppContext } from '@/contexts/AppContext';
import { useUnits } from '@/hooks/units';
import { Link } from '@tanstack/react-router';
import { useMemo, type FC } from 'react';

const FeaturedFloorPlansSection: FC = () => {
  const { community } = useAppContext();
  const { data: units } = useUnits.useSuspenseQuery([community.id]);

  const featuredUnits = useMemo(
    () => (units ?? []).sort((a, b) => a.id - b.id).slice(0, 3),
    [units],
  );

  if (featuredUnits.length === 0) {
    return null;
  }

  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Featured Floor Plans
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Explore our available floor plans and find your perfect home
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {featuredUnits.map((unit) => (
            <PropertyCard
              key={`property-card-${unit.property?.id}`}
              property={unit.property}
              unit={unit}
            />
          ))}
        </div>

        <div className="text-center">
          <Link to="/floor-plans" className="btn-outline">
            View All Floor Plans
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedFloorPlansSection;
